import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { P, H6, H5, H4, H3, H2, H1 } from './text.style.js';

const Text = props => {
    const { children, className = '', color = 'primary', margin, opacity = 'high', textAlign = 'left', textStyle = 'paragraph500', tag = 'p' } = props, rest = __rest(props, ["children", "className", "color", "margin", "opacity", "textAlign", "textStyle", "tag"]);
    const passedProps = Object.assign({ className,
        color,
        margin,
        opacity,
        textStyle,
        textAlign }, rest);
    switch (tag) {
        case 'h1':
            return jsx(H1, Object.assign({}, passedProps, { children: children }), void 0);
        case 'h2':
            return jsx(H2, Object.assign({}, passedProps, { children: children }), void 0);
        case 'h3':
            return jsx(H3, Object.assign({}, passedProps, { children: children }), void 0);
        case 'h4':
            return jsx(H4, Object.assign({}, passedProps, { children: children }), void 0);
        case 'h5':
            return jsx(H5, Object.assign({}, passedProps, { children: children }), void 0);
        case 'h6':
            return jsx(H6, Object.assign({}, passedProps, { children: children }), void 0);
        default:
            return jsx(P, Object.assign({}, passedProps, { children: children }), void 0);
    }
};

export { Text };
